import React, {Suspense} from 'react';
import PageLayout from "@view/layout/pageLayout/PageLayout";
import SpinnerCustom from "@ui/spinner/SpinnerCustom";
import {
	VoyageTemplatesSingleVoyageLazy
} from "@containers/singleVoyage/voyageTemplates/list/VoyageTemplatesSingleVoyage.lazy";

const VoyageTemplatesSingleVoyagePage = () => {
	return (
		<PageLayout>
			<Suspense
				fallback={<SpinnerCustom/>}
			>
				<VoyageTemplatesSingleVoyageLazy/>
			</Suspense>
		</PageLayout>
	);
};

export default VoyageTemplatesSingleVoyagePage;
